import React from 'react'
import PropTypes from 'prop-types'
import fetch from 'whatwg-fetch'
import { Main, ShortFooter, ChimeIn } from '@ua-oira/crimson-tide'
import Nav from '../components/Navigation/Nav'
import NavLink from '../components/Navigation/NavLink'

if (typeof global.fetch === 'undefined') global.fetch = fetch

const NavLinks = [
  { title: 'Planning Group', path: '/planning-group' },
  { title: 'Steering Committee', path: '/steering-committee' },
  { title: 'FAQ', path: '/faq' },
  { title: 'Resources', path: '/resources' },
]

if (typeof global.fetch === 'undefined') global.fetch = fetch

const TemplateWrapper = ({ children }) => (
  <div className="react-root">
    <Nav image={ChimeIn} background="#900" links={NavLinks}>
      {NavLinks.map((link, i) => (
        <NavLink key={i} color="#900" to={link.path}>
          {link.title}
        </NavLink>
      ))}
    </Nav>
    <Main style={{ width: '2000px' }}>{children()}</Main>
    <ShortFooter />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js